(function() {
  const WIDGET_SELECTORS = [
    'recharge-subscription-widget',
    'recharge-widget',
    '[data-recharge-widget]'
  ];

  const STYLES = `
    .vpv-card-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      margin-bottom: 16px;
    }
    .vpv-now-card, .vpv-recurring-card {
      background: #fff;
      border-radius: 10px;
      padding: 14px;
    }
    .vpv-now-card > p, .vpv-recurring-card > p {
      margin: 0 0 8px;
      font-size: 16px;
      font-weight: 700;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .vpv-now-card > ul, .vpv-recurring-card > ul {
      margin: 0;
      padding-left: 20px;
      list-style: disc;
    }
    .vpv-now-card li, .vpv-recurring-card li {
      font-size: 14px;
      line-height: 1.5;
    }
    .vpv-recurring-card em {
      display: block;
      font-style: italic;
      font-size: 13px;
      color: #6b7280;
      margin-top: 4px;
    }
    .vpv-why-block > p {
      margin: 0 0 8px;
      font-size: 15px;
      font-weight: 700;
    }
    .vpv-why-block > ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    .vpv-why-block li {
      position: relative;
      padding-left: 24px;
      margin-bottom: 6px;
      font-size: 14px;
      line-height: 1.4;
    }
    .vpv-why-block li::before {
      content: '';
      position: absolute;
      left: 0;
      top: 4px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 1.5px solid currentColor;
      opacity: 0.6;
    }
    @media (max-width: 600px) {
      .vpv-card-row { grid-template-columns: 1fr; }
    }
  `;

  function findWidget() {
    for (const sel of WIDGET_SELECTORS) {
      const el = document.querySelector(sel);
      if (el?.shadowRoot) return el;
    }
    return null;
  }

  function restyleBenefits(widget) {
    const root = widget.shadowRoot;
    const list = root.querySelector('.rc-benefits__list');
    if (!list || list.dataset.vpvStyled === 'true') return;

    const children = Array.from(list.children).filter(
      c => c.tagName === 'P' || c.tagName === 'UL'
    );

    // Expect [p#1 "Now", ul#1, p#2 "Every X", ul#2, p#3 "Why Subscribe?", ul#3]
    if (children.length < 6) return;

    const nowCard = document.createElement('div');
    nowCard.className = 'vpv-now-card';
    nowCard.append(children[0], children[1]);

    const recurringCard = document.createElement('div');
    recurringCard.className = 'vpv-recurring-card';
    recurringCard.append(children[2], children[3]);

    const cardRow = document.createElement('div');
    cardRow.className = 'vpv-card-row';
    cardRow.append(nowCard, recurringCard);

    const whyBlock = document.createElement('div');
    whyBlock.className = 'vpv-why-block';
    whyBlock.append(children[4], children[5]);

    list.append(cardRow, whyBlock);
    list.dataset.vpvStyled = 'true';

    // Inject styles once into the shadow root
    if (!root.querySelector('style[data-vpv-styles]')) {
      const style = document.createElement('style');
      style.setAttribute('data-vpv-styles', 'true');
      style.textContent = STYLES;
      root.append(style);
    }
  }

  function watch(widget) {
    restyleBenefits(widget);

    const observer = new MutationObserver(() => {
      restyleBenefits(widget);
    });

    observer.observe(widget.shadowRoot, {
      childList: true,
      subtree: true
    });
  }

  // Poll for widget mount (app block loads async)
  const start = Date.now();
  const poll = setInterval(() => {
    const widget = findWidget();
    if (widget) {
      clearInterval(poll);
      watch(widget);
    } else if (Date.now() - start > 15000) {
      clearInterval(poll);
      console.warn('[recharge-benefits-restyle] widget never mounted');
    }
  }, 150);
})();